const upperCaseDefs = (s: string) => {
	if (typeof s !== 'string') return '';
	if (s === 'vot' || s === 'vow' || s === 'dvs' || s === 'push' || s === 'pull') return s.toUpperCase();
	return s;
};

export default upperCaseDefs;
